import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"note"}/>
}
